import { FORM_MODES } from 'config/formModes';
import { BASE_FORM_ROUTE_PATH, FORM_MODE_TO_PATH_MAP } from 'config/routes';
import { replacePathParams } from 'modules/campaigns/services/utils';
import { ACCOUNT_ID_PARAM_NAME, ACCOUNT_ID_PARAM_TEMPLATE } from './account';
import { CREATIVE_ID_PARAM_NAME, CREATIVE_ID_PARAM_TEMPLATE } from './creative';
import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

const KEY_TO_PATH_MAP_MAP = {
    mode: FORM_MODE_TO_PATH_MAP,
    entity: ENTITY_TO_PATH_MAP,
};

export const CREATIVE_LIBRARY_ROUTE_PATH = `${BASE_FORM_ROUTE_PATH}${ACCOUNT_ID_PARAM_TEMPLATE}${CREATIVE_ID_PARAM_TEMPLATE}`;

export const CREATIVE_LIBRARY_EDITOR_ROUTE_PATH = replacePathParams(
    CREATIVE_LIBRARY_ROUTE_PATH,
    {
        entity: [ENTITY.CREATIVE],
        mode: [FORM_MODES.EDIT, FORM_MODES.DUPLICATE],
    },
    [ACCOUNT_ID_PARAM_NAME, CREATIVE_ID_PARAM_NAME],
    KEY_TO_PATH_MAP_MAP
);

export const DISPLAY_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH = replacePathParams(
    CREATIVE_LIBRARY_ROUTE_PATH,
    {
        entity: [ENTITY.DISPLAY],
        mode: [FORM_MODES.CREATE],
    },
    [],
    KEY_TO_PATH_MAP_MAP
);

export const NATIVE_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH = replacePathParams(
    CREATIVE_LIBRARY_ROUTE_PATH,
    {
        entity: [ENTITY.NATIVE],
        mode: [FORM_MODES.CREATE],
    },
    [],
    KEY_TO_PATH_MAP_MAP
);

export const CREATIVE_LIBRARY_PREVIEW_ROUTE_PATH = replacePathParams(
    CREATIVE_LIBRARY_ROUTE_PATH,
    {
        entity: [ENTITY.CREATIVE],
        mode: [FORM_MODES.PREVIEW],
    },
    [ACCOUNT_ID_PARAM_NAME, CREATIVE_ID_PARAM_NAME],
    KEY_TO_PATH_MAP_MAP
);
